import { render } from "./WorkspacesModal1.vue?vue&type=template&id=c1f275d2&scoped=true"
import script from "./WorkspacesModal1.vue?vue&type=script&lang=js"
export * from "./WorkspacesModal1.vue?vue&type=script&lang=js"

import "./WorkspacesModal1.vue?vue&type=style&index=0&id=c1f275d2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anderson\\Documents\\GitHub\\px40-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1f275d2"]])

export default __exports__